// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__S6oz2","dragIcon":"SortableItem_dragIcon__29gPr","disabled":"SortableItem_disabled__1YJIK"};